const messages = {
  'lang_it': 'ITA',
  'lang_en': 'ENG',
  'visit': "Visita la casa",
  'more': "Leggi di più",
  'contact': "Contattaci",
  'houses': "Links",
  'rooms': "Le stanze",
  'book': "Prenota"
};

export default messages;



// WEBPACK FOOTER //
// ./src/locales/it.js